import { Link } from "react-router-dom";
import { Lock, Heart, Repeat, ThumbsUp, MessageCircle, Sparkles, MapPin, Hotel, ShoppingCart, Link2, ImageIcon } from "lucide-react";
import { StatusBadge } from "./StatusBadge";

export const EntryCard = ({ entry, currentUserId, onClick }) => {
  const isLocked = entry.is_locked;
  const isSecret = entry.is_secret && entry.created_by === currentUserId;
  const wishLabel =
    entry.wish_owner === "both" ? "Beider Wunsch" :
    entry.wish_owner === "a" && entry.created_by === currentUserId ? "Mein Wunsch" :
    entry.wish_owner === "b" && entry.created_by !== currentUserId ? "Mein Wunsch" :
    entry.wish_owner === "a" ? "Wunsch der Partner:in" :
    entry.wish_owner === "b" ? "Wunsch der Partner:in" : null;

  const voteCount = (entry.votes || []).length;
  const reactionCount = (entry.reactions || []).length;
  const commentCount = (entry.comments || []).length;

  if (isLocked) {
    return (
      <button
        onClick={onClick}
        data-testid={`entry-card-${entry.id}`}
        className="group w-full text-left bg-white border border-border rounded-2xl p-6 hover:border-ink/30 transition-colors relative overflow-hidden"
      >
        <div className="absolute -right-6 -top-6 w-24 h-24 rounded-full bg-bone opacity-50" />
        <div className="relative">
          <div className="flex items-center gap-2 text-text_secondary mb-3">
            <Lock size={14} />
            <span className="text-[10px] uppercase tracking-[0.25em]">Überraschung</span>
          </div>
          <div className="font-serif text-xl text-ink leading-snug">Eine Überraschung wartet auf dich</div>
          <div className="text-sm text-text_secondary mt-2">Dein:e Partner:in plant etwas Besonderes für euch.</div>
        </div>
      </button>
    );
  }

  const linkBadges = [
    entry.map_link && { Icon: MapPin, label: "Maps" },
    entry.hotel_link && { Icon: Hotel, label: "Hotel" },
    entry.amazon_link && { Icon: ShoppingCart, label: "Shop" },
    entry.external_link && { Icon: Link2, label: "Link" },
    (entry.images || []).length > 0 && { Icon: ImageIcon, label: `${entry.images.length}` },
  ].filter(Boolean);

  return (
    <button
      onClick={onClick}
      data-testid={`entry-card-${entry.id}`}
      className="group w-full text-left bg-white border border-border rounded-2xl p-5 sm:p-6 hover:border-ink/30 transition-colors flex flex-col gap-3"
    >
      <div className="flex items-start justify-between gap-3">
        <div className="flex flex-wrap items-center gap-2">
          <StatusBadge status={entry.status} />
          {entry.type === "recurring" && (
            <span className="inline-flex items-center gap-1 text-[10px] uppercase tracking-[0.2em] text-text_secondary border border-border rounded-full px-2 py-0.5">
              <Repeat size={10} /> {entry.rhythm}
            </span>
          )}
          {isSecret && (
            <span className="inline-flex items-center gap-1 text-[10px] uppercase tracking-[0.2em] text-terracotta border border-[#E0B4A1] rounded-full px-2 py-0.5">
              <Lock size={10} /> Geheim
            </span>
          )}
        </div>
        {wishLabel && (
          <span className="text-[10px] uppercase tracking-[0.2em] text-text_secondary flex items-center gap-1">
            <Heart size={10} /> {wishLabel}
          </span>
        )}
      </div>

      <div className="font-serif text-xl text-ink leading-snug">{entry.title}</div>
      {entry.description && (
        <div className="text-sm text-text_secondary line-clamp-2">{entry.description}</div>
      )}

      {(entry.tags || []).length > 0 && (
        <div className="flex flex-wrap gap-1.5">
          {entry.tags.slice(0, 4).map((t) => (
            <span key={t} className="text-[10px] uppercase tracking-wider text-text_secondary bg-bone rounded-full px-2 py-0.5">{t}</span>
          ))}
        </div>
      )}

      <div className="mt-auto flex items-center justify-between pt-2 border-t border-border/60">
        <div className="flex items-center gap-3 text-text_secondary text-xs">
          {linkBadges.map(({ Icon, label }) => (
            <span key={label} className="flex items-center gap-1"><Icon size={12} /> {label}</span>
          ))}
        </div>
        <div className="flex items-center gap-3 text-text_secondary text-xs">
          {voteCount > 0 && <span className="flex items-center gap-1"><ThumbsUp size={12} /> {voteCount}</span>}
          {reactionCount > 0 && <span className="flex items-center gap-1"><Sparkles size={12} /> {reactionCount}</span>}
          {commentCount > 0 && <span className="flex items-center gap-1"><MessageCircle size={12} /> {commentCount}</span>}
        </div>
      </div>
    </button>
  );
};

export default EntryCard;
